import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  overflow: hidden;
  background-color: ${COLORS.bgWhite};
`

export const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 20px 24px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`

export const CardPreview = styled.div`
  display: flex;
  align-items: center;
  padding: 24px 20px 24px 24px;
  width: 100%;
  height: 180px;
  border-radius: 12px;
  background-color: #1b1c1d;
  box-sizing: border-box;
`

export const CardPreviewInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  min-width: 0;
  height: 100%;
  color: ${COLORS.bgWhite};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.08px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const CardPreviewNumber = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`

export const CardPreviewExpiry = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`

export const CardPreviewIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  color: ${COLORS.bgWhite};
`

export const RadioGroup = styled.div`
  display: flex;
  gap: 24px;
  padding: 8px 0;
`

export const RadioRow = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 500;
  color: ${COLORS.textPrimary};
  cursor: pointer;
`

export const HiddenRadio = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
`

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const FieldRow = styled.div`
  display: flex;
  gap: 12px;
  & > * {
    flex: 1;
    min-width: 0;
  }
`

export const InputField = styled.input`
  width: 100%;
  padding: 16px 20px;
  border: 1px solid ${COLORS.strokeStatic};
  border-radius: 12px;
  background-color: ${COLORS.bgWhite};
  font-size: 16px;
  color: ${COLORS.textPrimary};
  outline: none;

  &::placeholder {
    color: ${COLORS.textMuted};
  }

  &:focus {
    border-color: ${COLORS.brand};
  }
`

export const CardNumberInputWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const CardNumberInput = styled(InputField)`
  padding-right: 48px;
`

export const ClearButton = styled.button`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 0;
  border-radius: 9999px;
  background-color: ${COLORS.textMuted};
  color: ${COLORS.bgWhite};
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
`

export const ErrorText = styled.p`
  margin: 0;
  padding: 0 4px;
  font-size: 13px;
  color: #b42318;
  /* message + 백엔드 description 을 줄바꿈(\n)으로 함께 노출 */
  white-space: pre-line;
`

export const SubmitBar = styled.div`
  padding: 16px 20px calc(16px + var(--safe-bottom, 0px));
  background-color: ${COLORS.bgWhite};
  border-top: 1px solid ${COLORS.strokeStatic};
`
